import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { LucideIcon } from 'lucide-react';

interface SidebarLink {
  name: string;
  href: string;
  icon: LucideIcon;
}

interface PageWithSidebarProps {
  title: string;
  sidebarLinks: SidebarLink[];
  children: ReactNode;
}

export function PageWithSidebar({ title, sidebarLinks, children }: PageWithSidebarProps) {
  return (
    <div className="flex">
      <Sidebar title={title} links={sidebarLinks} />
      <div className="flex-1 p-8 animate-fade-in">
        {children}
      </div>
    </div>
  );
}
